
const arrayToDic = (array) => {
  return array.reduce((p, c) => {
    if (c) p[c] = 1
    return p
  }, {})
}

export default arrayToDic
